import { useEffect, useState } from 'react';
import { IDataRequest, IDataRequestsApi } from '@vivli/features/data-requests/infrastructure/interface';
import { filter, finalize } from 'rxjs/operators';
import { IActiveUser, IMyDataRequestsApi } from '@vivli/core/infrastructure/interface';

interface IMyDataRequestsInitHook {
    activeUser: IActiveUser;
    dataRequestsApi: IDataRequestsApi;
}

export function useMyDataRequestsApi({ activeUser, dataRequestsApi }: IMyDataRequestsInitHook): IMyDataRequestsApi {
    const [myDataRequests, setMyDataRequests] = useState<IDataRequest[]>();
    const [isLoadingMyDataRequests, setIsLoadingMyDataRequests] = useState(false);
    const [showRequestAddedBadge, setShowRequestAddedBadge] = useState(false);

    const popRequestAddedBadge = () => {
        setShowRequestAddedBadge(true);
        setTimeout(() => {
            setShowRequestAddedBadge(false);
        }, 5000);
    };

    const addDataRequest = (dataRequest: IDataRequest) => {
        if (!myDataRequests.some((r) => r.id === dataRequest.id)) {
            setMyDataRequests([...myDataRequests, dataRequest]);
        }
        popRequestAddedBadge();
    };

    const updateMyDataRequest = (dataRequest: IDataRequest) => {
        const updatedDataRequests = myDataRequests?.map((r) => {
            if (r.id === dataRequest.id) {
                return dataRequest;
            }

            return r;
        });

        setMyDataRequests(updatedDataRequests);
    };

    useEffect(() => {
        if (activeUser.user === null) {
            return;
        }

        setIsLoadingMyDataRequests(true);
        const dataRequestsSub = dataRequestsApi
            .getMyDataRequests()
            .pipe(
                filter((dr) => dr !== null),
                finalize(() => setIsLoadingMyDataRequests(false))
            )
            .subscribe(setMyDataRequests);

        return () => {
            dataRequestsSub.unsubscribe();
        };
    }, [activeUser.user]);

    return {
        myDataRequests,
        setMyDataRequests,
        isLoadingMyDataRequests,
        showRequestAddedBadge,
        addDataRequest,
        updateMyDataRequest,
        popRequestAddedBadge,
    };
}
